export enum UpgradeRequiredViewTypes {
    INLINE = 'INLINE',
    FULL_PAGE = 'FULL_PAGE'
}